module.exports = __webpack_public_path__ + "static/media/4.5c9e9f1c.jpg";